import React from 'react';
import Home from './components/Home/Home';
import Main from './components/Main/Main';
import './App.css';

function App() {
  return (
    <div className="App">
      <Home />
      <Main />
    </div>
  );
}

export default App;
